/**
 * 인증 폼(로그인·회원가입·비밀번호 재설정) 공통 모양.
 * 밑줄 입력칸 — 스토어 카테고리 탭과 같은 밑줄 언어. 포커스하면 밑줄이 검게 진해지고,
 * 브라우저 자동완성의 파란 바탕은 흰 바탕으로 덮는다.
 */
export const UNDERLINE_INPUT_CLASS =
  'h-12 rounded-none border-0 border-b border-foreground/15 bg-transparent px-0 text-[15px] focus-visible:border-foreground focus-visible:ring-0 [&:-webkit-autofill]:shadow-[inset_0_0_0_1000px_var(--background)]';

/** 제출 버튼 — 흑연 알약, 글자는 왼쪽·화살표는 오른쪽. */
export const SUBMIT_BUTTON_CLASS =
  'mt-2 h-12 w-full justify-between px-6 text-[15px] font-semibold tracking-[-0.01em]';
